<template>
  <SiteHeader :tickets-to="route.path === '/kaartverkoop' ? '#avond' : '/kaartverkoop'" />
  <main :class="$style['layout__main']">
    <slot />
  </main>
  <SiteTicketTape v-if="route.path !== '/kaartverkoop'" />
  <SiteFooter />
</template>
<script setup>
const { load, navigation } = useNavigation()
const { formatDefault, formatBreadcrumbs } = useHrMeta()
const route = useRoute()
useStageTheme()
formatDefault()

watch(() => route.path, () => {
  formatBreadcrumbs(navigation)
})
await load()
</script>
<style module>
.layout__main {
  /* Short pages may end sooner instead of leaving a black void above the footer */
  min-height: 60svh;
}
</style>
